import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { Text } from '@chakra-ui/react';
const JsFormGroupNameFC = ({ name }) => {
    return (_jsx(Text, { mb: '8px', p: '15px 0 4px 0', fontSize: "12px", color: "bodyText", fontWeight: 600, overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis", borderBottom: `1px solid`, borderColor: 'border', children: _jsx("span", { children: name }) }));
};
export const JsFormGroupName = memo(JsFormGroupNameFC);
//# sourceMappingURL=JsFormGroupName.js.map